/// <reference path="../typings/jquery/jquery.d.ts" />
/// <reference path="../typings/flickity.d.ts" />

declare var jQuery;
let $ = jQuery;
import Slideshow = require("./Components/Slideshow");

$(document).ready(function() {
	
	let slideshow = new Slideshow($(".slideshow"));
	slideshow.start();

	$('.testimonial-box').flickity({
		// options
		contain: true,
		draggable: false,
		pageDots: true,
		wrapAround: true,
		cellAlign: 'left'
	});

	let iso_wrapper = $("#portfolio-list").isotope({
		itemSelector: '.list-item',
	});





	var $footer_slider = $("#footer-logo-slider");
	$footer_slider.flickity({
		draggable: true,
		cellAlign: "left",
		freeScroll: true,
		prevNextButtons: false,
		pageDots: false,
		wrapAround: true,
		autoPlay: 2500
	});





	// Init filters object
	var portfolio_filters = {};
	$('[data-iso-filter]').on('click', function(){

		var button = $(this),
			filterValue = button.attr('data-iso-filter'),
			filterGroup = button.parents('.portfolio-filter-list').attr('data-filter-group');

		// Add the value to the group
		portfolio_filters[filterGroup] = filterValue;
		// Concat vals to create a new filter value
		var newFilterVal = concatValues(portfolio_filters);
		// Filter the isotope container
		iso_wrapper.isotope({ filter: newFilterVal });
		// Clear all active classes in the wrapper
		button.parents('.portfolio-filter-list').find('[data-iso-filter]').removeClass('active');
		button.addClass('active');

		return false;
	});

});
function concatValues(obj) {
	var value = '';
	for (var prop in obj) {
		value += obj[prop];
	}
	return value;
}